import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Visitor } from '../../models/visitor';
import { VisitorService } from '../../services/visitor.service';
import { map } from 'rxjs/operators';
import { VisitorChild } from '../../models/visitorChild';
import { Visitor1 } from '../../models/visitor1';
import { VisitorChild1 } from '../../models/visitorChild1';
import { Visit } from '../../models/visit.model';
import { VisitService } from '../../services/visit.service';
import { PlayroomService } from '../../services/playroom.service';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { Playroom } from '../../models/playroom.model';
import { CostumArray } from '../../models/customArray';
import { RoomArray } from '../../models/roomArray';
import { ZoneArray } from '../../models/zoneArray';
import { Zone } from '../../models/zone.model';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { BirthDay } from '../../models/birthday.model';
import { User } from 'src/app/models/user.model';
import { UserService } from '../../services/user.service';
import { validateBirthDay } from 'src/app/utils/formValidators';
import { CommonMethodesService } from '../../services/common-methodes.service';
import { CalendarWeek } from '../../models/CalendarWeek';
import { TimeSlotConfigurationService } from '../../services/time-slot-configuration.service';
import { CalendarSlotCell } from '../../models/CalendarSlotCell';
import { SlotsbyDate } from '../../models/SlotsbyDate';
import { CallListService } from '../../services/call-list.service';
import { NotifierService } from 'angular-notifier';
import { LanguageService } from 'src/app/services/language.service';
import { BirthDayAddsArray } from '../../models/birthDayAddsArray';
import { BirthdayModelInputDTO } from '../../models/birthdayModelInputDTO';
import { BirthdayOutput } from '../kartica-visitora/kartica-visitora.page';
import { BirthdayListService } from '../../services/birthday-list.service';
import { PaginationSettings } from '../../models/paginationsettings';


@Component({
  selector: 'app-birthday-edit-form-from-calendar',
  templateUrl: './birthday-edit-form-from-calendar.component.html',
  styleUrls: ['./birthday-edit-form-from-calendar.component.scss'],
})
export class BirthdayEditFormFromCalendarComponent implements OnInit {
  visitor: any;
  visits: Visit[]
  visitorCh: VisitorChild1[]
  itemsPerPageLarge: number = 2147483647;
  itemsPerPage: number = 2147483647;
  isAddBirthay: boolean = false

  usernameQuery: string = '';
  fullNameQuery: string = '';

  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  currentPage: number = 1;
  onlyChildren: boolean = false;
  marketingMessageQuery: string = '';
  routeBirthdayId: number | null = null;
  routeSavedTimeSlotId: number | null = null;

  message: string = ''
  paginationSettings: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20
  };

  paginationSettingsBirthday: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 10
  };
  paginationSettingsCalls: PaginationSettings = {
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20
  };




  constructor(private route: ActivatedRoute, private visitorService: VisitorService,
    private visitService: VisitService,
    private roomService: PlayroomService,
    private rodjendanskezoneservice: RodjendanskezoneService,
    private commonMethodsService: CommonMethodesService,
    private callListService: CallListService,
    private notifierService: NotifierService,
    private router: Router,
    private toastController: ToastController,
    private birthdayListService: BirthdayListService,
    private cd: ChangeDetectorRef
  ) { }

  async presentToast(message: string, color: 'success' | 'danger' = 'success') {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color,
      position: 'bottom',
      cssClass: 'custom-toast'
    });

    await toast.present();
  }
  birthdays$ = this.birthdayListService.birthdays$;
  calls$ = this.callListService.calls$;

  visitors$ = this.visitorService.visitors$;
  visits$ = this.visitService.visit$
  errMsg = '';

  birthDateQuery: string = '';
  roomQuery: string = '';
  statusQuery: string = '';
  registrationDateFromQuery: string = ""
  registrationDateToQuery: string = ""
  dateQuery: string = '';
  dateQueryEnd: string = '';
  roomName: string = '';
  enterTimeQuery: string = '';
  enterTimeQueryEnd: string = '';
  packageTicketType: string = '';
  dateBirthFromQuery: string = ''
  dateBirthToQuery: string = ''
  visitorBirthMonthFromQuery: string = ""
  visitorBirthMonthToQuery: string = ""
  visitorBirthYearFromQuery: string = ""
  visitorBirthYearToQuery: string = ""
  timeZoneQuery: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  gratis: boolean
  gratisQuery: string = ""
  playroom: Playroom[]
  userList: Array<CostumArray>;
  selectedUser: CostumArray | null = null
  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null
  zoneList: Array<ZoneArray>
  selectedZone: ZoneArray | null = null
  birthdayAdd: BirthDay
  startTimeBirthdayQuery = ''
  endTimeBirthdayQuery = ''
  zone: Zone[]
  users: User[];
  messageError: string = ''
  errMsgInputTime: string = ''
  errMsgInputDate: string = ''
  availibleslots: SlotsbyDate[] = []
  isCreateMode = false;
  datumpoziva: string = ''
  routeSavedBirthdayId = null
  birthdayAdds: { name: string; quantity: string; price: number; }[] = [
    { name: '', quantity: '', price: null }
  ];
  birthDayAdssPriceTotal: number = null
  createChildren: Array<{ fullName: string; birthDate: string }> = [
    { fullName: '', birthDate: '' },
  ];
  phonePrefixes = [
    { code: '+381', flag: 'rs' }, // Srbija  
    { code: '+387', flag: 'ba' }, // Bosna i Hercegovina
    { code: '+389', flag: 'mk' }, // Severna Makedonija  
    { code: '+385', flag: 'hr' }, // Hrvatska  
    { code: '+382', flag: 'me' }, // Crna Gora
    { code: '+7', flag: 'ru' }, // Rusija  
    { code: '+380', flag: 'ua' }, // Ukrajina  
    { code: '+49', flag: 'de' }, // Nemačka 
    { code: '+355', flag: 'al' }, // Albanija  
    { code: '+376', flag: 'ad' }, // Andora  
    { code: '+43', flag: 'at' }, // Austrija  
    { code: '+374', flag: 'am' }, // Jermenija  
    { code: '+32', flag: 'be' }, // Belgija   
    { code: '+359', flag: 'bg' }, // Bugarska  
    { code: '+357', flag: 'cy' }, // Kipar  
    { code: '+420', flag: 'cz' }, // Češka  
    { code: '+45', flag: 'dk' }, // Danska  
    { code: '+372', flag: 'ee' }, // Estonija  
    { code: '+358', flag: 'fi' }, // Finska  
    { code: '+33', flag: 'fr' }, // Francuska  
    { code: '+995', flag: 'ge' }, // Gruzija  
    { code: '+30', flag: 'gr' }, // Grčka  
    { code: '+36', flag: 'hu' }, // Mađarska  
    { code: '+354', flag: 'is' }, // Island  
    { code: '+353', flag: 'ie' }, // Irska  
    { code: '+39', flag: 'it' }, // Italija  
    { code: '+371', flag: 'lv' }, // Letonija  
    { code: '+423', flag: 'li' }, // Lihtenštajn  
    { code: '+370', flag: 'lt' }, // Litvanija  
    { code: '+352', flag: 'lu' }, // Luksemburg  
    { code: '+356', flag: 'mt' }, // Malta  
    { code: '+373', flag: 'md' }, // Moldavija  
    { code: '+377', flag: 'mc' }, // Monako  
    { code: '+31', flag: 'nl' }, // Holandija  
    { code: '+47', flag: 'no' }, // Norveška  
    { code: '+48', flag: 'pl' }, // Poljska  
    { code: '+351', flag: 'pt' }, // Portugal  
    { code: '+40', flag: 'ro' }, // Rumunija  
    { code: '+421', flag: 'sk' }, // Slovačka  
    { code: '+386', flag: 'si' }, // Slovenija  
    { code: '+34', flag: 'es' }, // Španija  
    { code: '+46', flag: 'se' }, // Švedska  
    { code: '+41', flag: 'ch' }, // Švajcarska  
    { code: '+44', flag: 'gb' }, // Velika Britanija  
    { code: '+90', flag: 'tr' },  // Turska
    { code: '+1', flag: 'us' }, // Sjedinjene Američke Države
    { code: '+1', flag: 'ca' }, // Kanada
    { code: '+61', flag: 'au' }  // Australija
  ];
  selectedPrefix = this.phonePrefixes[0]; // Default: +381 (Srbija)
  dropdownOpen = false;
  inputs = {
    fullName: "",
    ['fullNameChild1']: "",
    phone: "",
    phonePrefix: "+381",
    email: "",
    day: "",
    month: "",
    year: ""
  };
  fromDate: Date | null = null
  toDate: Date | null = null

  //
  birthdayListQuery: {
    currentPage: number;
    itemsPerPage: number;
    cityQuery: string;
    roomNameQuery: string;
    birthdayZoneNameQuery: string;
    visitorIdQuery: number | null;
    CallDateFromQuery: string;
    CallDateToQuery: string;
    AppointmentDateFromQuery: string;
    AppointmentDateToQuery: string;
    PricePerChildrenFromQuery: string;
    PricePerChildrenToQuery: string,
    PlannedChildNumberFromQuery: string;
    PlannedChildNumberToQuery: string;
    PresentChildNumberFromQuery: string;
    PresentChildNumberToQuery: string;
    TotalPricePaidFromQuery: string;
    TotalPricePaidToQuery: string;
    StatusCallQuery: string;
    NumberOfBirthdayFromQuery: string;
    NumberOfBirthdayToQuery: string;
    AdvancePaymentWillQuery: string;
    AdvancePricePaidFromQuery: string;
    AdvancePricePaidToQuery: string;
  } = {
      currentPage: 1,
      itemsPerPage: 10,
      cityQuery: '',
      roomNameQuery: '',
      birthdayZoneNameQuery: '',
      visitorIdQuery: null,
      CallDateFromQuery: '',
      CallDateToQuery: '',
      AppointmentDateFromQuery: '',
      AppointmentDateToQuery: '',
      PricePerChildrenFromQuery: '',
      PricePerChildrenToQuery: '',
      PlannedChildNumberFromQuery: '',
      PlannedChildNumberToQuery: '',
      PresentChildNumberFromQuery: '',
      PresentChildNumberToQuery: '',
      TotalPricePaidFromQuery: '',
      TotalPricePaidToQuery: '',
      StatusCallQuery: '0',
      NumberOfBirthdayFromQuery: '',
      NumberOfBirthdayToQuery: '',
      AdvancePaymentWillQuery: '',
      AdvancePricePaidFromQuery: '',
      AdvancePricePaidToQuery: ''
    };

  callListQuery: {
    currentPage: number,
    itemsPerPage: number,
    dateFrom: string,
    dateTo: string,
    operatorExtension: string,
    status: string,
    phoneQuery: string,
    durationFromQuery: string,
    durationToQuery: string

  }
    = {
      currentPage: 1,
      itemsPerPage: 20,
      dateFrom: '',
      dateTo: '',
      operatorExtension: '',
      status: '',
      phoneQuery: '',
      durationFromQuery: '',
      durationToQuery: ''

    };



  StatusList: number[] = [];
  PhoneCallStatusList: number[] = [];
  operators: any[] = [];

  OperatorExtensionsList = []




  async ngOnInit() {

    this.callListService.callPagination$
      .subscribe(pag => {
        if (!pag) return;
        this.paginationSettings = {
          totalItems: pag.totalItems,
          currentPage: this.paginationSettings.currentPage,
          itemsPerPage: pag.itemsPerPage

        };

      });

    this.getOperatorsArray()

    this.StatusList = null;
    this.PhoneCallStatusList = null


    this.birthdayAdd = new BirthDay();
    const qp = this.route.snapshot.queryParamMap;
    this.routeSavedTimeSlotId = qp.get('savedTimeSlotId') ? +qp.get('savedTimeSlotId')! : null;
    if (this.routeSavedTimeSlotId === null) {
      this.routeSavedBirthdayId = qp.get('birthdayId') ? +qp.get('birthdayId')! : null;
      this.loadBirthdayByBirthdayId(this.routeSavedBirthdayId)

    }
    else {
      this.loadBirthdayBySavedSlot(this.routeSavedTimeSlotId);
    }

    this.loadVisit()

   
    this.visitor = new Visitor();
    const Calldatedate = Date.now()
    const CalllDate = new Date(Calldatedate);
    const CallfromDate = new Date(Date.UTC(
      CalllDate.getFullYear(),
      CalllDate.getMonth(),
      CalllDate.getDate(),
      0, 0, 0
    ));
    this.birthdayAdd.CallStatus = 2
    this.birthdayAdd.advancePaymentWill = 0
    this.birthdayAdd.CallDate = CalllDate
    this.datumpoziva = this.formatDateForInput(this.birthdayAdd.CallDate)

    this.birthdayListService.birthdayPagination$.subscribe(pagSettings => {
      this.paginationSettingsBirthday = { ...pagSettings }; // ← kopija
    });

    this.callListService.callPagination$.subscribe(pagSettings => {
      this.paginationSettingsCalls = { ...pagSettings }; // ← kopija
    });


    this.callListQuery.phoneQuery = this.visitor.phone

  }
  getVisitorFromList(visitorId: number) {
    return this.visitorService.getVisitorById(visitorId);
  }

  get filteredChildren() {
    const children = this.visitor?.children;
    if (!Array.isArray(children)) {
      return [];
    }
    return children.filter(c => typeof c === 'object' && c?.fullName);
  }

  loadVisit() {
    this.currentPage = 1;
    this.visitService.getAllVisitsAdminManagerRoleDirect({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      birthDateQuery: this.birthDateQuery,
      roomQuery: this.roomQuery,
      statusQuery: this.statusQuery,
      dateQuery: this.dateQuery,
      dateQueryEnd: this.dateQueryEnd,
      enterTimeQuery: this.enterTimeQuery,
      enterTimeQueryEnd: this.enterTimeQueryEnd,
      timeZoneQuery: this.timeZoneQuery,
      gratisQuery: this.gratisQuery,
      packageTicketType: this.packageTicketType
    }).subscribe(({ visits, pagination }) => {
      this.visits = visits;
      this.paginationSettings = pagination;
    });
  }

  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }


  downloadSignature(visitor) {
    const guid = visitor.signatureUrl.split('Signature/')[1];
    this.visitorService.getSignature(guid).subscribe(res => {
      const source = URL.createObjectURL(res);
      const el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", `${visitor.fullName.replace(/\s/g, '_')}${visitor.phone}`);
      document.body.appendChild(el);
      el.click();
      el.remove();
    })
  }

  onUserChange(event: any) {
    this.getReducedArray()
    this.zoneList = []
    this.birthdayAdd.city = this.selectedUser.display
  }

  onRoomChange(event: any) {
    this.selectedZone = null;
    this.zoneList = [];

    if (!this.selectedRoom) {
      console.warn('Nije izabrana igraonica.');
      return;
    }
    this.birthdayAdd.roomId = parseInt(this.selectedRoom.value);
    this.commonMethodsService.getEmployeesByRoom(
      this.birthdayAdd.roomId,
      this.currentPage,
      this.itemsPerPage
    ).subscribe(employees => {
      if (employees.length > 0) {

      }
    });

    this.birthdayAdd.roomId = parseInt(this.selectedRoom.value);
    this.commonMethodsService.getEmployeesByRoom(
      this.birthdayAdd.roomId,
      this.currentPage,
      this.itemsPerPage
    ).subscribe(employees => {
      if (employees.length > 0) {
        this.birthdayAdd.EmployeeId = employees[0].id;
        this.birthdayAdd.EmployName = employees[0].username;
      }
    });
    this.getReducedZoneArray();

  }

  compareRooms(o1: RoomArray, o2: RoomArray): boolean {
    return o1 && o2 ? parseInt(o1.value) === parseInt(o2.value) : o1 === o2;
  }
  compareZone = (o1: ZoneArray, o2: ZoneArray) => {
    return o1 && o2 ? o1.value === o2.value : o1 === o2;
  };

  onZoneChange(event: any) {
    if (!this.selectedZone) {
      console.warn('selectedZone nije postavljen.');
      return;
    }

    this.birthdayAdd.BirthdayZoneId = parseInt(this.selectedZone.value);

    const aa = this.birthdayAdd.IsFlexible
  }



  getReducedArray() {

    this.roomList = []
    var disp = this.selectedUser?.display
    this.roomList = this.mapPlayroomsToRoomList(this.playroom, disp);

    this.zoneList = []

  }

  getReducedZoneArray() {
    if (!this.selectedRoom) {
      console.warn('selectedRoom nije postavljen, preskačem mapiranje zona.');
      this.zoneList = [];
      this.selectedZone = null;
      return;
    }

    this.rodjendanskezoneservice.getAllPlayroomZonesSub({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage
    }).subscribe(data => {
      this.zone = data;
      const disp = this.selectedRoom.display;
      this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, disp);

      if (this.zoneList.length > 0 && this.birthdayAdd.BirthdayZoneId) {
        const foundZone = this.zoneList.find(

          z => parseInt(z.value) === this.birthdayAdd.BirthdayZoneId
        );
        this.selectedZone = foundZone ?? null;
      } else {
        this.selectedZone = null;
      }

    });
  }

  onAvansChange(event: any) {

    this.birthdayAdd.advancePaymentWill
  }

  private ymdToDate(ymd?: string | Date | null): Date | null {
    if (!ymd) return null;
    if (ymd instanceof Date) return ymd;
    const [y, m, d] = ymd.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(Date.UTC(y, m - 1, d, 0, 0, 0, 0));
  }

  private buildIsoFromDateAndTimetoLocal(dayYmd?: string | Date | null, timeHHmm?: string | null): string | null {
    if (!dayYmd || !timeHHmm) return null;

    timeHHmm = String(timeHHmm).trim();

    if (!timeHHmm.includes(':')) {
      timeHHmm = timeHHmm.padStart(2, '0') + ':00';
    }

    const base = this.ymdToDate(dayYmd);
    if (!base) return null;

    const [hhStr, mmStr] = timeHHmm.split(':');
    const hh = Number(hhStr) || 0;
    const mm = Number(mmStr) || 0;

    base.setHours(hh, mm, 0, 0);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return (
      base.getFullYear() + '-' +
      pad(base.getMonth() + 1) + '-' +
      pad(base.getDate()) + 'T' +
      pad(base.getHours()) + ':' +
      pad(base.getMinutes()) + ':' +
      pad(base.getSeconds())
    );

  }

  private buildIsoFromDateAndTime(dayYmd?: string | Date | null, timeHHmm?: string | null): string | null {
    if (!dayYmd || !timeHHmm) return null;

    timeHHmm = String(timeHHmm).trim();

    if (!timeHHmm.includes(':')) {
      timeHHmm = timeHHmm.padStart(2, '0') + ':00';
    }

    const base = this.ymdToDate(dayYmd);
    if (!base) return null;

    const [hhStr, mmStr] = timeHHmm.split(':');
    const hh = Number(hhStr) || 0;
    const mm = Number(mmStr) || 0;

    base.setHours(hh, mm, 0, 0);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return base.toISOString();
  }

  updateBirthday(): void {
    if (this.routeSavedTimeSlotId) {
      this.updateBirthdayBySlot()

    }
    else {
      this.updateBirthdayById()

    }
  }

  updateBirthdayBySlot() {

    this.birthdayAdd.VisitorId = this.visitor?.id ?? null;
    this.birthdayAdd.roomId = this.selectedRoom ? parseInt(this.selectedRoom.value, 10) : null;
    this.birthdayAdd.BirthdayZoneId = this.selectedZone ? parseInt(this.selectedZone.value, 10) : null;

    const formValidation = validateBirthDay(this.birthdayAdd);
    this.errMsg = formValidation.errMsg;
    if (!formValidation.isValid) return;


    if (!this.routeSavedTimeSlotId) {
      this.notifierService?.notify?.('error', 'Nedostaje savedTimeSlotId (query param).');
      return;
    }
    const adds = (this.birthdayAdds || []).map(x => ({
      name: (x.name ?? '').trim(),
      quantity: (x.quantity ?? '').toString().trim(),
      price: +x.price || 0
    }));

    const advancePaymentWillNum =
      this.birthdayAdd.advancePaymentWillString === '1'
        ? 1
        : (this.birthdayAdd.advancePaymentWill ? 1 : 0);

    const birthDayEndsIso =
      this.buildIsoFromDateAndTime(this.birthdayAdd.AppointmentDate, this.birthdayAdd.endTimeBirthday)
      || this.birthdayAdd.BirthDayEnds
      || null;

    if (!birthDayEndsIso) {
      this.notifierService?.notify?.('error', 'Unesi vreme završetka rođendana.');
      return;
    }

    const dto: BirthdayModelInputDTO = {
      id: (this.routeBirthdayId ?? this.birthdayAdd.Id ?? 0) as number,
      roomId: this.birthdayAdd.roomId!,
      city: this.birthdayAdd.city || '',

      BirthdayZoneId: this.birthdayAdd.BirthdayZoneId!,
      VisitorId: this.birthdayAdd.VisitorId!,
      EmployeeId: this.birthdayAdd.EmployeeId,

      Discount: this.birthdayAdd.Discount || 0,
      advancePaymentWill: this.birthdayAdd.advancePaymentWill,
      advancePaymentWillString: this.birthdayAdd.advancePaymentWillString ?? (advancePaymentWillNum ? '1' : '0'),
      AdvancePayment: this.birthdayAdd.AdvancePayment || 0,
      FinalPlannedPrice: this.birthdayAdd.FinalPlannedPrice ?? (
        (this.birthdayAdd.PlannedPrice || 0) -
        ((this.birthdayAdd.PlannedPrice || 0) * (this.birthdayAdd.Discount || 0) / 100)
      ),

      CallDate: this.birthdayAdd.CallDate ?? new Date(),
      AppointmentDate: this.ymdToDate(this.birthdayAdd.AppointmentDate)!,

      PricePerChildren: this.birthdayAdd.pricePerChildren || 0,
      PlannedChildNumber: this.birthdayAdd.PlannedChildNumber,
      PresentChildNumber: this.birthdayAdd.PresentChildNumber,

      TotalPricePaid: this.birthdayAdd.TotalPricePaid || 0,

      TotalPricePaidWithoutDicount:
        this.birthdayAdd.TotalPricePaidWithoutDicount ??
        (
          (this.birthdayAdd.presentChildNumber != null && this.birthdayAdd.presentChildNumber > 0)
            ? (this.birthdayAdd.pricePerChildren * this.birthdayAdd.presentChildNumber)
            : (this.birthdayAdd.pricePerChildren * this.birthdayAdd.plannedChildNumber)
        ),


      TotalPricePaidAdds: this.birthdayAdd.TotalPricePaidAdds || 0,
      TotalPricePaidWithAdds: this.birthdayAdd.TotalPricePaidWithAdds ??
        ((this.birthdayAdd.TotalPricePaid || 0) + (this.birthdayAdd.TotalPricePaidAdds || 0)),

      CallStatus: this.birthdayAdd.CallStatus ?? 0,
      EmployName: this.birthdayAdd.EmployName || '',

      startTimeBirthday: this.birthdayAdd.startTimeBirthday || '',
      BirthdayStart: this.buildIsoFromDateAndTime(this.birthdayAdd.AppointmentDate, this.birthdayAdd.startTimeBirthday),
      BirthDayEnds: birthDayEndsIso,
      SavedTimeSlotId: this.birthdayAdd.SavedTimeSlotId,
      roomName: this.birthdayAdd.selectedRoom,
      AddsTotalNamePrices: adds,
      CommentBirthdayAppointment: this.birthdayAdd.CommentBirthdayAppointment || '',
      NumberOfBirthday: this.birthdayAdd.NumberOfBirthday || 0,

      isFlexible: false,
      SavedTimeEndSlotId: null,
      BirthDayEndsDt: null,
      endTimeBirthday: '',



    };


    this.visitorService.updateBirthdayBySlot(dto, this.birthdayAdd.Id).subscribe({

      next: () => {
        this.notifierService?.notify?.('success', 'Rođendan je uspešno ažuriran.');
        this.presentToast('Rođendan je uspešno ažuriran.', 'success');
        this.router.navigate(
          ['admin/birthday-booking'],
          {
            replaceUrl: true,
            queryParams: {
              roomId: this.birthdayAdd.roomId,
              zoneId: this.birthdayAdd.BirthdayZoneId,
              appointmentDate: (this.birthdayAdd as any).AppointmentDate,
              birthdayStart: (this.birthdayAdd as any).BirthdayStart
            }
          }
        );
      },
      error: (err) => {
        console.error(err);
        const msg = err?.error?.title || 'Greška prilikom ažuriranja.';
        this.notifierService?.notify?.('error', msg);
      }
    });

  }
  updateBirthdayById() {
    this.birthdayAdd.VisitorId = this.visitor?.id ?? null;
    this.birthdayAdd.roomId = this.selectedRoom ? parseInt(this.selectedRoom.value, 10) : null;
    this.birthdayAdd.BirthdayZoneId = this.selectedZone ? parseInt(this.selectedZone.value, 10) : null;



    const adds = (this.birthdayAdds || []).map(x => ({
      name: (x.name ?? '').trim(),
      quantity: (x.quantity ?? '').toString().trim(),
      price: +x.price || 0
    }));

    const advancePaymentWillNum =
      this.birthdayAdd.advancePaymentWillString === '1'
        ? 1
        : (this.birthdayAdd.advancePaymentWill ? 1 : 0);

    const birthDayEndsIso =
      this.buildIsoFromDateAndTime(this.birthdayAdd.AppointmentDate, this.birthdayAdd.endTimeBirthday)
      || this.birthdayAdd.BirthDayEnds
      || null;

    if (!birthDayEndsIso) {
      this.notifierService?.notify?.('error', 'Unesi vreme završetka rođendana.');
      return;
    }


    const dto: BirthdayModelInputDTO = {
      id: (this.routeBirthdayId ?? this.birthdayAdd.Id ?? 0) as number,
      roomId: this.birthdayAdd.roomId!,
      city: this.birthdayAdd.city || '',

      BirthdayZoneId: this.birthdayAdd.BirthdayZoneId!,
      VisitorId: this.birthdayAdd.VisitorId!,
      EmployeeId: this.birthdayAdd.EmployeeId,

      Discount: this.birthdayAdd.Discount || 0,
      advancePaymentWill: this.birthdayAdd.advancePaymentWill,
      advancePaymentWillString: this.birthdayAdd.advancePaymentWillString ?? (advancePaymentWillNum ? '1' : '0'),
      AdvancePayment: this.birthdayAdd.AdvancePayment || 0,
      FinalPlannedPrice: this.birthdayAdd.FinalPlannedPrice ?? (
        (this.birthdayAdd.PlannedPrice || 0) -
        ((this.birthdayAdd.PlannedPrice || 0) * (this.birthdayAdd.Discount || 0) / 100)
      ),

      CallDate: this.birthdayAdd.CallDate ?? new Date(),
      AppointmentDate: this.ymdToDate(this.birthdayAdd.AppointmentDate)!,

      PricePerChildren: this.birthdayAdd.pricePerChildren || 0,
      PlannedChildNumber: this.birthdayAdd.PlannedChildNumber,
      PresentChildNumber: this.birthdayAdd.PresentChildNumber,

      TotalPricePaid: this.birthdayAdd.TotalPricePaid || 0,

      TotalPricePaidWithoutDicount:
        this.birthdayAdd.TotalPricePaidWithoutDicount ??
        (
          (this.birthdayAdd.presentChildNumber != null && this.birthdayAdd.presentChildNumber > 0)
            ? (this.birthdayAdd.pricePerChildren * this.birthdayAdd.presentChildNumber)
            : (this.birthdayAdd.pricePerChildren * this.birthdayAdd.plannedChildNumber)
        ),


      TotalPricePaidAdds: this.birthdayAdd.TotalPricePaidAdds || 0,
      TotalPricePaidWithAdds: this.birthdayAdd.TotalPricePaidWithAdds ??
        ((this.birthdayAdd.TotalPricePaid || 0) + (this.birthdayAdd.TotalPricePaidAdds || 0)),

      CallStatus: this.birthdayAdd.CallStatus ?? 0,
      EmployName: this.birthdayAdd.EmployName || '',

      startTimeBirthday: this.birthdayAdd.startTimeBirthday || '',
      BirthdayStart: this.buildIsoFromDateAndTime(this.birthdayAdd.AppointmentDate, this.birthdayAdd.startTimeBirthday),
      BirthDayEnds: birthDayEndsIso,
      SavedTimeSlotId: this.birthdayAdd.SavedTimeSlotId,

      AddsTotalNamePrices: adds,
      CommentBirthdayAppointment: this.birthdayAdd.CommentBirthdayAppointment || '',
      NumberOfBirthday: this.birthdayAdd.NumberOfBirthday || 0,

      roomName: this.birthdayAdd.roomName,
      isFlexible: false,
      SavedTimeEndSlotId: null,
      BirthDayEndsDt: null,
      endTimeBirthday: ''


    };

    this.birthdayListService.editBirthdayList(dto, this.birthdayAdd.Id).subscribe(res => {
      this.notifierService?.notify?.('success', 'Rođendan je uspešno ažuriran.');
      this.presentToast('Rođendan je uspešno ažuriran.', 'success');
      this.router.navigate(
        ['admin/birthday-booking'],
        {
          replaceUrl: true,
          queryParams: {
            roomId: this.birthdayAdd.roomId,
            zoneId: this.birthdayAdd.BirthdayZoneId,
            appointmentDate: (this.birthdayAdd as any).AppointmentDate,
            birthdayStart: (this.birthdayAdd as any).BirthdayStart
          }
        }
      );


    }, (error) => {
      if (error.error.errors.includes("Birthday-appoitment - is- allredy-booked")) {
        this.messageError = 'Termin je zauzet.';
        alert('Termin je zauzet!');
      }
      else if (error.error.errors.includes("No-Availible- slots")) {
        this.messageError = 'Nema raspoloživih termina.';
        alert('Nema raspoloživih termina!');
      }
      JSON.stringify(error.error.title);
    });



  }

  getStartTimeQuery(val: Date | string): string {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  getEndTimeQuery(val) {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;

  }

  private fromUtcToLocalTime(utcTimeStr: string, dateContext: string): string {

    const dateOnly = dateContext.split('T')[0];
    const fullUtcStr = `${dateOnly}T${utcTimeStr}${utcTimeStr.includes('Z') ? '' : 'Z'}`;
    const localDate = new Date(fullUtcStr);
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onAppoitmentDateChanged(preserveSelected = false) {
    if (!preserveSelected) {
      this.birthdayAdd.SavedTimeSlotId = null;
      this.birthdayAdd.SavedTimeEndSlotId = null;
      this.birthdayAdd.startTimeBirthday = null;
    }
    this.errMsgInputDate = ''
    if (!preserveSelected) {
      this.birthdayAdd.startTimeBirthday = null;
    }
    const appointmentDate = new Date(this.birthdayAdd.AppointmentDate);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));

    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));

    this.visitorService.getSavedTimeSlots(
      this.birthdayAdd.roomId,
      this.birthdayAdd.BirthdayZoneId,
      fromDate,
      toDate
    ).subscribe({
      next: (slots) => {

        this.availibleslots = slots.map(slot => ({
          ...slot,
          start: this.fromUtcToLocalTime(slot.start, this.birthdayAdd.AppointmentDate),
          end: this.fromUtcToLocalTime(slot.end, this.birthdayAdd.AppointmentDate)
        }));
        this.birthdayAdd.isFlexible = false;
        for (let s = 0; s < this.availibleslots.length; s++) {

          if (this.availibleslots[s].isFlexible === true) {
            this.birthdayAdd.isFlexible = true;
            break;
          }


        }
      },
      error: (error) => {

        console.warn('getSavedTimeSlots error (validacija isključena):', error);
      }

    });
  }

  onStartTimeChanged() {

    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.startTimeBirthday) {

      const [hours, minutes] = this.birthdayAdd.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayStartDt = date;
      this.birthdayAdd.BirthDayStart = new Date(
        this.birthdayAdd.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayAdd.startTimeBirthday) {


          this.visitorService.getSavedTimeSlotById(this.availibleslots[i].id).subscribe({
            next: (data) => {

            },
            error: (error) => {
              if (error.status === 400) {
                alert('Termin je zauzet!');
                this.birthdayAdd.startTimeBirthday = null

              } else {
                console.error('Neočekivana greška:', error);
              }
            }
          });


          this.birthdayAdd.endTimeBirthday = this.availibleslots[i].end;

          const [hours, minutes] = this.birthdayAdd.endTimeBirthday.split(':').map(Number);

          const date = new Date(this.birthdayAdd.AppointmentDate);
          date.setHours(hours, minutes, 0, 0);

          this.birthdayAdd.BirthDayEndsDt = date;

          this.birthdayAdd.BirthDayEnds = this.birthdayAdd.BirthDayEndsDt.toISOString();

          this.birthdayAdd.SavedTimeSlotId = this.availibleslots[i].id;
          break;
        }
      }
    }
  }

  onStartTimeChangedFlex() {
    this.birthdayAdd.SavedTimeSlotId = null
    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.startTimeBirthday) {
      this.errMsgInputTime = '';

      const [hours, minutes] = this.birthdayAdd.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayStartDt = date;

      this.birthdayAdd.BirthDayStart = new Date(
        this.birthdayAdd.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayAdd.startTimeBirthday) {

          this.birthdayAdd.SavedTimeSlotId = this.availibleslots[i].id
          break;

        }
      }
    }
  }

  onEndTimeChangedFlex() {
    if (this.birthdayAdd.AppointmentDate && this.birthdayAdd.endTimeBirthday) {
      this.errMsgInputTime = '';
      const [hours, minutes] = this.birthdayAdd.endTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayAdd.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayEndsDt = date;

      this.birthdayAdd.BirthDayEnds = new Date(
        this.birthdayAdd.BirthDayEndsDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.birthdayAdd.SavedTimeSlotId === null) {

          this.birthdayAdd.SavedTimeSlotId = -1
        }


        if (this.availibleslots[i].start === this.birthdayAdd.endTimeBirthday) {
          this.birthdayAdd.SavedTimeEndSlotId = this.availibleslots[i].id

          this.visitorService.getSavedTimeSlotByIdStartEnd(this.birthdayAdd.SavedTimeSlotId, this.birthdayAdd.SavedTimeEndSlotId).subscribe({
            next: (data) => {
            },
            error: (error) => {

              if (error.error.errors.includes('Slots cant be null')) {
                this.messageError = 'Morate uneti vremena početka i završetka rodjendana.';
                alert('Morate uneti vremena početka i završetka rodjendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null

              }
              else if (error.error.errors.includes('Birthday-appoitment - is- allredy-booked')) {
                this.messageError = 'Termin je zauzet.';
                alert('Termin je zauzet!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null
              }
              else if (error.error.errors.includes('EndTime - and- StartTime cant be same')) {
                this.messageError = 'Vreme završetka rođendana mora biti veće od vremena početka rođendana.';
                alert('Vreme završetka rođendana mora biti veće od vremena početka rođendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeSEndlotId = null

              }

              else {
                console.error('Neočekivana greška:', error);
              }
              this.errMsgInputTime = this.messageError



            }
          });

          this.birthdayAdd.SavedTimeSEndlotId = this.availibleslots[i].id
          break;
        }
      }
    }
  }

  statusCallHelper(value: number) {
    if (value === 0) {
      return "ZAKAZAN"
    }
    else if (value === 1) {
      return "OTKAZAN"
    }
    else if (value === 2) {
      return "RASPITUJE SE"

    }
    else if (value === 3) {
      return "RAZMISLIĆE"

    }

    else if (value === 4) {
      return "POZVATI GA"

    }
  }


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  private updateCallStatusOnly(birthId: number): void {
    const callIdStr = localStorage.getItem('callId');
    if (!callIdStr) {
      console.warn('callId nije pronađen u localStorage – preskačem PUT zahtev');
      return;
    }

    const callId = Number(callIdStr);
    if (isNaN(callId)) {
      console.warn('callId je NaN – preskačem PUT zahtev');
      return;
    }
    this.callListService.setBirthdayCall(birthId, callId).subscribe({
      next: () => { },
      error: err => console.error('Greška pri ažuriranju statusa rođendana:', err)
    });

    localStorage.removeItem("callId");
  }
  selectPrefix(prefix: { code: string; flag: string }) {
    this.selectedPrefix = prefix;
    this.inputs.phonePrefix = prefix.code;
    this.dropdownOpen = false;
  }

  addInputField() {
    this.birthdayAdds.push({ name: '', quantity: '', price: 0 });

  }


  removeInputField(index: number) {

    if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal === 0) {

      return
    }

    else if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.addInputField()
      this.recalculateTotal()

    }

    else if (index === 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()
    }
    else if (index > 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()
    }
  }

  onAddsPriceChange(event: any) {
    this.recalculateTotal()
  }
  private recalculateTotal() {
    this.birthDayAdssPriceTotal = 0;
    for (let j = 0; j < this.birthdayAdds.length; j++) {
      this.birthDayAdssPriceTotal += this.birthdayAdds[j].price;
    }
    this.birthdayAdd.AddsTotalNamePrices = this.birthdayAdds
    this.birthdayAdd.TotalPricePaidWithAdds = this.birthdayAdd.TotalPricePaid + this.birthDayAdssPriceTotal
    this.birthdayAdd.TotalPricePaidAdds = this.birthDayAdssPriceTotal
  }

  onPriceNumberBlur(idx: number) {
    const v = +this.birthdayAdds[idx].price;
    if (isNaN(v)) return;
    this.birthdayAdds[idx].price = Math.round((v + Number.EPSILON) * 100) / 100;
    this.onAddsPriceChange(null);
  }

  private loadBirthdayBySavedSlot(savedTimeSlotId: number) {
    this.visitorService.getBirthdayBySavedSlot(savedTimeSlotId).subscribe({
      next: (b) => {


        this.patchBirthdayToForm(b);

        this.routeBirthdayId = b?.id ?? this.routeBirthdayId;
        this.loadCityObjectZone()
        this.getVisitorFromList(b.visitorId).subscribe(visitor => {
          if (visitor) {
            this.isCreateMode = false
            this.visitor = visitor;
            this.visitorCh = this.visitor.children

            this.visitor.children = this.visitor.children.map(child => ({
              ...child,
              birthDate: child.birthDate ? child.birthDate.split('T')[0] : ''
            }));
           
          this.uploadBirthdayList(this.visitor.id);
          this.loadSearchResult(this.visitor.phone);
          }
        })
      },
      error: (err) => this.logHttpError('[Kartica] Greška (by saved slot)', err)
    });
  }

  trackByIndex(index: number) {
    return index;
  }

  trackByChildId(_i: number, c: VisitorChild1) {
    return (c as any)?.id ?? c?.fullName ?? _i;
  }


  private logHttpError(prefix: string, err: any) {
    console.error(prefix, err);
    console.error('status:', err?.status, 'statusText:', err?.statusText, 'url:', err?.url);
    console.error('server payload:', err?.error);
  }

  mapPlayroomsToRoomList(playroom: Playroom[], disp: string): RoomArray[] {
    const result: RoomArray[] = [];
    const city = (disp || '').trim().toLowerCase();

    for (let i = 0; i < (playroom?.length || 0); i++) {
      const p = playroom[i];
      const address = (p?.address || '').trim().toLowerCase();

      const match = address.includes(city);

      if (match) {
        const item = new RoomArray();
        item.value = String(p.id);
        item.display = String(p.roomName);
        result.push(item);
      }
    }
    return result;
  }

  get appointmentDatePretty(): string {
    const s = this.birthdayAdd?.AppointmentDate;
    return s ? new Date(s + 'T00:00:00').toLocaleDateString('sr-RS') : '';
  }

  private toLocalISOKeepingFormat(utcInput: string | Date | number): string {
    let d: Date;

    if (typeof utcInput === 'string') {
      const normalized = utcInput.endsWith('Z') ? utcInput : utcInput + 'Z';
      d = new Date(normalized);
    } else {
      d = new Date(utcInput);
    }

    if (isNaN(d.getTime())) throw new Error('Invalid date');

    const pad = (n: number) => String(n).padStart(2, '0');


    return (
      `${d.getFullYear()}-` +
      `${pad(d.getMonth() + 1)}-` +
      `${pad(d.getDate())}T` +
      `${pad(d.getHours())}:` +
      `${pad(d.getMinutes())}:` +
      `${pad(d.getSeconds())}`
    );
  }



  private patchBirthdayToForm(b: any) {

    console.groupEnd();
    this.birthdayAdd.Id = b.id;
    this.birthdayAdd.city = b.city ?? '';
    this.birthdayAdd.roomId = b.roomId ?? null;
    this.birthdayAdd.selectedRoom = b.roomName;
    this.birthdayAdd.BirthdayZoneId = b.birthdayZoneId ?? null;

    console.log("b.TotalPricePaidWithoutDicount", b.totalPricePaidWithoutDicount)
    console.log(" b.presentChildNumber", b.presentChildNumber)
    console.log(" b.pricePerChildren", b.pricePerChildren)
    if (b.pricePerChildren === 0) {
      this.birthdayAdd.TotalPricePaidWithoutDicount = b.totalPricePaidWithoutDicount
    }
    else {
      this.birthdayAdd.TotalPricePaidWithoutDicount = b.presentChildNumber * b.pricePerChildren || b.plannedChildNumber * b.pricePerChildren
    }
    this.birthdayAdd.AppointmentDate = (b.appointmentDate ?? b.AppointmentDate ?? '')
      .toString()
      .slice(0, 10);

    const localTime = this.toLocalISOKeepingFormat(b.birthdayStart);


    let startDisplay: Date | null = null;
    if (localTime) {
      startDisplay = new Date(localTime);


    }

    this.birthdayAdd.startTimeBirthday = startDisplay
      ? this.getStartTimeQuery(startDisplay)
      : null;;


    const localEndTime = this.toLocalISOKeepingFormat(b.birthDayEnds);
    let endDispaly: Date | null = null;
    if (localEndTime) {
      endDispaly = new Date(localEndTime);
    }
    this.birthdayAdd.endTimeBirthday = endDispaly
      ? this.getEndTimeQuery(endDispaly)
      : null;

    this.birthdayAdd.BirthDayStart = localTime ?? null;
    this.birthdayAdd.BirthDayEnds = localEndTime ?? null;

    this.birthdayAdd.NumberOfBirthday = b.numberOfBirthday ?? null;

    this.birthdayAdd.pricePerChildren = b.pricePerChildren ?? null;

    this.birthdayAdd.Discount = b.discount ?? 0;
    this.birthdayAdd.FinalPlannedPrice = b.finalPlannedPrice ??
      (this.birthdayAdd.PlannedPrice - (this.birthdayAdd.PlannedPrice * (this.birthdayAdd.Discount || 0) / 100));

    // izmene posle spajanja sa granom  us663_NEW
    this.birthdayAdd.advancePaymentWill = b.advancePaymentWill
    this.birthdayAdd.advancePaymentWillString = String(this.birthdayAdd.advancePaymentWill);

    this.birthdayAdd.AdvancePayment = b.advancePayment ?? 0;

    this.birthdayAdd.PlannedChildNumber = b.plannedChildNumber ?? null;
    this.birthdayAdd.PresentChildNumber = b.presentChildNumber ?? null;

    this.birthdayAdd.TotalPricePaid = b.totalPricePaid ?? 0;
    this.birthdayAdd.TotalPricePaidAdds = b.totalPricePaidAdds ?? 0;
    this.birthdayAdd.TotalPricePaidWithAdds = b.totalPricePaidWithAdds ??
      ((this.birthdayAdd.TotalPricePaid || 0) + (this.birthdayAdd.TotalPricePaidAdds || 0));

    this.birthdayAdd.EmployeeId = b.employeeId ?? null;
    this.birthdayAdd.EmployName = b.employeeName ?? '';

    this.birthdayAdd.CallDate = b.callDate ? new Date(b.callDate) : new Date();
    this.datumpoziva = this.formatDateForInput(this.birthdayAdd.CallDate);

    this.birthdayAdd.CallStatus = b.callStatus ?? 0;
    this.birthdayAdd.VisitorId = b.visitorId || b.VisitorId
    this.birthdayAdd.SavedTimeSlotId = b.savedTimeSlotId ?? this.birthdayAdd.SavedTimeSlotId ?? null;
    this.birthdayAdd.SavedTimeEndSlotId = b.savedTimeEndSlotId ?? this.birthdayAdd.SavedTimeEndSlotId ?? null;
    this.birthdayAdds = Array.isArray(b.addsTotalNamePrices) && b.addsTotalNamePrices.length
      ? b.addsTotalNamePrices.map((x: any) => ({
        name: x.name || '',
        quantity: x.quantity || '',
        price: +x.price || 0
      }))
      : [{ name: '', quantity: '', price: 0 }];
    const hasAnyAdds =
      Array.isArray(b.addsTotalNamePrices) &&
      b.addsTotalNamePrices.some((x: any) => (+x?.price || 0) > 0);

    const paidAdds = hasAnyAdds
      ? (b.totalPricePaidAdds != null)
        ? +b.totalPricePaidAdds
        : (b.totalPricePaidWithAdds != null && b.totalPricePaid != null)
          ? (+b.totalPricePaidWithAdds) - (+b.totalPricePaid)
          : 0
      : 0;

    this.birthDayAdssPriceTotal = paidAdds;
    this.birthdayAdd.TotalPricePaidWithAdds =
      (+this.birthdayAdd.TotalPricePaid || 0) + this.birthDayAdssPriceTotal;

    this.birthdayAdd.CommentBirthdayAppointment = b.commentBirthdayAppointment ?? '';



    setTimeout(() => this.onAppoitmentDateChanged(true), 0);

  }

  compareTimeHHmm = (a?: string, b?: string) => {
    if (!a || !b) return a === b;
    const toHM = (v: string) => v.length >= 5 ? v.slice(0, 5) : v;
    return toHM(a) === toHM(b);
  };

  get startTimeDisplay(): string {
    const v = this.birthdayAdd?.startTimeBirthday || '';
    return v.slice(0, 5);
  }

  onPresentChildNumberChange() {

    const present = Number(this.birthdayAdd.PresentChildNumber);
    const price = Number(this.birthdayAdd.pricePerChildren);
    console.log("PPresent", present)
    console.log("PRICE", price)
    if (present !== 0) {
      this.birthdayAdd.TotalPricePaidWithoutDicount = present * price;
    }
    else {
      const planned = Number(this.birthdayAdd.PlannedChildNumber);
      const price = Number(this.birthdayAdd.pricePerChildren);
      console.log("PLANNED", planned)
      console.log("PRICE", price)
      this.birthdayAdd.TotalPricePaidWithoutDicount = planned * price;
    }
    this.onDiscountChange(event)
    this.recalculateTotal()

  }
  onDiscountChange(event: any) {
    if (this.birthdayAdd.PresentChildNumber === null) {
      this.birthdayAdd.TotalPricePaid = this.birthdayAdd.TotalPricePaidWithoutDicount - (this.birthdayAdd.TotalPricePaidWithoutDicount * this.birthdayAdd.Discount / 100)
      this.recalculateTotal()
    }
    else {
      this.birthdayAdd.TotalPricePaid = this.birthdayAdd.TotalPricePaidWithoutDicount - (this.birthdayAdd.TotalPricePaidWithoutDicount * this.birthdayAdd.Discount / 100)
      this.recalculateTotal()

    }
    this.birthdayAdd.TotalPricePaid = this.birthdayAdd.TotalPricePaidWithoutDicount - (this.birthdayAdd.TotalPricePaidWithoutDicount * this.birthdayAdd.Discount / 100)
    this.recalculateTotal()
  }
  onPlannedChildNumberChange() {

    console.log("/this.birthdayAdd.PresentChildNumber/onPlannedChildNumberChange()", this.birthdayAdd.PresentChildNumber)
    if (this.birthdayAdd.PresentChildNumber === 0 || this.birthdayAdd.PresentChildNumber === null) {

      const planned = Number(this.birthdayAdd.PlannedChildNumber);
      const price = Number(this.birthdayAdd.pricePerChildren);
      console.log("PLANNED", planned)
      console.log("PRICE", price)
      this.birthdayAdd.TotalPricePaidWithoutDicount = planned * price;
      this.onDiscountChange(event)
      this.recalculateTotal()
      console.log("/ulazi u if")

    }
  }
  onPricePerChildrenChange(event: any) {
    console.log("this.birthdayAdd.presentChildNumber/onPricePerChildrenChange", this.birthdayAdd.PresentChildNumber)
    if (this.birthdayAdd.PresentChildNumber === 0 || this.birthdayAdd.PresentChildNumber === null) {
      this.onPlannedChildNumberChange()
    }
    else {
      console.log("Ulazi u else")
      const present = Number(this.birthdayAdd.PresentChildNumber);
      const price = Number(this.birthdayAdd.pricePerChildren);
      console.log("Present", present)
      console.log("PRICE", price)
      this.birthdayAdd.TotalPricePaidWithoutDicount = present * price;
      this.onDiscountChange(event)
      this.recalculateTotal()

    }
  }
  onFullPriceChange(event: any) {

    this.onDiscountChange(event)
    this.recalculateTotal()

  }

  private loadBirthdayByBirthdayId(savedTimeSlotId: number) {
    this.visitorService.getBirthdayById(savedTimeSlotId).subscribe({


      next: (b) => {


        this.patchBirthdayToForm(b);
        this.routeBirthdayId = b?.id ?? this.routeBirthdayId;

        this.loadCityObjectZone()


        this.getVisitorFromList(this.birthdayAdd.VisitorId).subscribe(visitor => {

          if (visitor) {
            this.isCreateMode = false
            this.visitor = visitor;
             
            this.visitorCh = this.visitor.children

            this.visitor.children = this.visitor.children.map(child => ({
              ...child,
              birthDate: child.birthDate ? child.birthDate.split('T')[0] : ''
            }));
            
           this.uploadBirthdayList(this.visitor.id)
           this.loadSearchResult(this.visitor.phone);
          }
        })
      },
      error: (err) => this.logHttpError('[Kartica] Greška (by saved slot)', err)
    });
  }



  formatTimeForInput(dateString: string): string {
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }



  formatTimeForInputStart(date: Date | string): string {
    const d = new Date(date);

    const hour = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0')

    console.log('RETURN', `${hour}:${minutes}`)
    return `${hour}:${minutes}`;
  }

  formatTimeForInputEnd(date: Date | string): string {


    const d = new Date(date);
    console.log("tIME END DATE d", d)
    const hour = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0')

    console.log('RETURN', `${hour}:${minutes}`)
    return `${hour}:${minutes}`;
  }

  convertLocalDateToLocalString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  parseUtcToLocal(dateString: string): Date {

    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds || 0));
  }

  formatApoitmentFrom() {

    const appointmentDate = new Date(this.birthdayAdd.appointmentDateInput);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));
    this.fromDate = fromDate
  }

  formatApoitmentTo() {
    const appointmentDate = new Date(this.birthdayAdd.appointmentDateInput);
    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));
    this.toDate = toDate
  }

  async getSlots(fromDate: Date, toDate: Date): Promise<any[]> {
    try {
      const slots = await this.visitorService.getSavedTimeSlots(
        this.birthdayAdd.roomId,
        this.birthdayAdd.BirthdayZoneId,
        fromDate,
        toDate
      ).toPromise();

      // Konvertuj UTC slotove u lokalno vreme
      this.availibleslots = slots.map(slot => ({
        ...slot,
        start: this.fromUtcToLocalTime(slot.start, this.birthdayAdd.AppointmentDate),
        end: this.fromUtcToLocalTime(slot.end, this.birthdayAdd.AppointmentDate)
      }));

      console.log('Slotovi stigli:', this.availibleslots);
      return this.availibleslots;
    } catch (err) {
      console.error('Greška u getSlots:', err);
      return [];
    }
  }


  loadCityObjectZone() {

    this.roomService.getAllPlayroomsSub().subscribe(async data => {
      this.playroom = data;
      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);

      this.selectedUser = this.userList.find(x => x.display === this.birthdayAdd.city);

      this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, this.birthdayAdd.city);


      this.selectedRoom = this.roomList.find(
        x => x.display === this.birthdayAdd.selectedRoom
      );

      console.log(this.selectedRoom, "this.selectedRoom")
      console.log("RoomName:", this.birthdayAdd.roomName);
      console.log(this.birthdayAdd, "this.birthdayAdd")

      this.rodjendanskezoneservice.getAllPlayroomZonesSub({ currentPage: this.currentPage, itemsPerPage: this.itemsPerPageLarge }).subscribe(async data => {
        this.zone = data;
        var disp = this.roomList;
        this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, this.birthdayAdd.roomName);

        this.selectedZone = this.zoneList.find(
          x => x.display === this.birthdayAdd.birthdayZoneName
        );

        this.birthdayAdd.BirthdayZoneId = parseInt(this.selectedZone.value)
        console.log("this.routeSavedTimeSlotId", this.routeSavedTimeSlotId)
        if (this.routeSavedTimeSlotId !== null) {
          console.log("AddEdit method nije ušao u if", this.routeSavedTimeSlotId)
        }

        if (this.routeSavedTimeSlotId === null) {
          console.log("AddEdit method ušao u if", this.routeSavedTimeSlotId)
          this.birthdayAdd.callDateInput = this.formatDateForInput(this.birthdayAdd.callDate);
          this.birthdayAdd.appointmentDateInput = this.formatDateForInput(this.birthdayAdd.appointmentDate);
          this.formatApoitmentFrom()
          this.formatApoitmentTo()
          await this.getSlots(this.fromDate, this.toDate)
        }



        this.birthdayAdd.startTimeBirthday = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayAdd.birthdayStart)
            )
          )

        this.birthdayAdd.inititialBitrthayStart = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayAdd.birthdayStart)
            )
          )


        this.birthdayAdd.endTimeBirthday = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayAdd.birthDayEnds)
            )
          )


        console.log('vlada Ngonit this.birthdayAdd', this.birthdayAdd)
        console.log('vlada Ngonit this.birthdayListList.startTimeBirthday', this.birthdayAdd.startTimeBirthday)
        console.log('vlada Ngonit this.birthdayListList', this.birthdayAdd)
      })
    });

  }

  async uploadBirthdayList(visitorId: number) {
    this.birthdayListQuery.currentPage = 1;
    this.birthdayListQuery.visitorIdQuery = visitorId
    await this.birthdayListService.getAllBirthday(this.birthdayListQuery);
  }
  async changePageBirthday(page: number) {
    const safePage = Math.max(page, 1);
    this.paginationSettingsBirthday.currentPage = page;
    this.birthdayListQuery.currentPage = page;

    try {
      const result = await Promise.race([
        this.birthdayListQuery.visitorIdQuery = this.visitor?.id ?? null,
        this.birthdayListService.getAllBirthday(this.birthdayListQuery),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Timeout: server nije odgovorio na vreme')), 5000)
        )
      ]);


    } catch (err) {
      console.error('Greška pri učitavanju rođendana:', err);
    }
  }

  changePageCalls(pageNumber: number) {
    this.paginationSettings.currentPage = pageNumber;
    this.loadSearchResult(this.visitor?.phone);
  }

  stats = [{
    totalCount: 0,
    filteredCount: 0,
    percentFiltered: 0,
    totalDurationAll: 0,
    totalDurationFiltered: 0,
    minDuration: 0,
    maxDuration: 0,
    avgDuration: 0,
    percentFilteredCalls: 0
  }];

  getOperatorsArray() {
    this.callListService.getOperators().subscribe({
      next: (res) => {
        this.operators = res || [];
        console.log(this.operators, "this operators")
        this.operators.forEach(op => op.selected = true);
        this.OperatorExtensionsList = this.operators.map(op => op.operaterId);
        console.log(this.OperatorExtensionsList, "this.operatorExtensionsList")
      //  this.reload()

      },
      error: (err) => console.error('Greška pri učitavanju operatera:', err),

    });

  }

  loadSearchResult(phoneQuery?: string) {

    this.callListService.getAllCallsSearch({
      pageNumber: this.paginationSettings.currentPage,
      pageSize: this.paginationSettings.itemsPerPage,
      currentPage: this.paginationSettings.currentPage,
      itemsPerPage: this.paginationSettings.itemsPerPage,
      operatorExtension: null,
      phoneQuery: phoneQuery || null,
      StatusList: this.StatusList,
      dateFrom: this.callListQuery.dateFrom || null,
      dateTo: this.callListQuery.dateTo || null,
      durationFromQuery: this.callListQuery.durationFromQuery || null,
      durationToQuery: this.callListQuery.durationToQuery || null,

      PhoneCallStatusList: this.PhoneCallStatusList,

      OperatorsExtensionList: this.OperatorExtensionsList ?? []
    }).subscribe({
      next: (res) => {
        this.stats = res;
        console.log("Operators Stats", this.stats)
      },
      error: (err) => {
        console.error('Greška pri učitavanju statistike:', err);
      }
    });
  }
}